import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { CountryModel } from './country'
import { Country } from './cou';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class CountryService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allCounty(): Promise<CountryModel[]> {
        return this.httpmanagerService.HttpGet('country', "").then(data => {
            return data.data;
        })
    }
    bulkinsert(): Promise<Country> {
        return this.httpmanagerService.HttpPost('country', JSON.stringify({}), "").then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/country/country.service.ts